import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';


//import { CustomButtonsModule } from '@shared/buttons';
import { AlertDialogComponent } from './alert-dialog.component';
import { AlertDialogService } from './alert-dialog.service';

@NgModule({
  imports: [
    CommonModule,
    MatButtonModule,
    MatCardModule,
    MatDialogModule,
    MatIconModule,
    FormsModule,
    MatInputModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    TranslateModule,
   // CustomButtonsModule,
  ],
  exports: [AlertDialogComponent],
  declarations: [AlertDialogComponent],
  entryComponents: [AlertDialogComponent],
  providers: [AlertDialogService],
})
export class AlertDialogModule {}
